export default __webpack_public_path__ + "static/media/U.d4803647.svg";